import { useI18n } from 'hooks/useI18n';
import { UIOfferFaqsSection } from 'interfaces/ui/ui-offer-faqs-section';
import JobOfferSection from '../JobOfferSection';
import Faqs from './Faqs';
import { StyledFaqsSection } from './FaqsSection.styled';

const FaqsSection = ({ faqs, migratedToMarkdown }: UIOfferFaqsSection) => {
  const { t } = useI18n('job-offer');

  if (!faqs || faqs.length <= 0) {
    return <></>;
  }

  return (
    <JobOfferSection name="faqs" title={t('titles.faqs')}>
      <StyledFaqsSection>
        {faqs.map((f, i) => (
          <Faqs key={i} faqsItem={f} migratedToMarkdown={migratedToMarkdown} />
        ))}
      </StyledFaqsSection>
    </JobOfferSection>
  );
};

export default FaqsSection;
